import { useAuthentication } from 'root/src/client/v2/auth/hooks/useAuthentication';
export function useIsAuthenticated() {
    const { authentication } = useAuthentication();
    return Boolean(authentication);
}
